<template>
  <div>
    <div class="d-flex justify-content-between align-items-center">
      <ol class="breadcrumb breadcrumb-alt">
        <li @click="rollback(val, index)" v-for="(val, index) of breadcrumb" :key="index" class="breadcrumb-item">
          <a class="link-fx" href="javascript:void(0)">{{ val.name }}</a>
        </li>
      </ol>
      <form v-on:submit.prevent class="d-none d-md-inline-block" style="width: 20rem">
        <div class="input-group input-group-sm">
          <input
            type="text"
            class="form-control"
            placeholder="Recherche..."
            id="search"
            name="search"
            v-model="researchValue"
            @input="searchInput"
          />
          <span class="input-group-text">
            <i class="fa fa-fw fa-search"></i>
          </span>
        </div>
        <v-app style="height: 4px; background-color: transparent;">
            <v-progress-linear v-if="loading" indeterminate color="#3E4254"></v-progress-linear>
        </v-app>
      </form>
    </div>
    <!-- <v-progress-linear indeterminate color="yellow darken-2" style="width: 100%"></v-progress-linear> -->

    <!-- Category -->
    <div class="mt-4" v-if="showCategories">
      <!-- Categories 'Type Object' - Catégories -->
      <div v-if="!Array.isArray(actualCards)" class="row items-push">
        <div
          v-for="(value, name) in actualCardsWithoutColor"
          :key="name"
          @click="nextStep(value, name, value?.id)"
          class="col-4 col-md-3"
        >
          <div
            class="block block-rounded rounded-24 h-100 mb-0 ratio ratio-1x1 shadow"
            :style="hasCustomColor(value) ? `background-color: ${getCustomColor(value)}` : 'background-color: #FFF'"
            role="button"
          >
            <div class="block-content d-flex justify-content-center align-items-center" style="flex-direction: column">
                <svg  xmlns="http://www.w3.org/2000/svg" width="84" height="84" viewBox="0 0 84 84">
                    <g  v-if="name == 'Prestations'" id="prestations" transform="translate(-711 -289)">
                        <g id="Ellipse_78" data-name="Ellipse 78" transform="translate(711 289)" fill="#efefef" stroke="#c3c3c3" stroke-width="1">
                            <circle cx="42" cy="42" r="42" stroke="none"/>
                            <circle cx="42" cy="42" r="41.5" fill="none"/>
                        </g>
                        <g id="man-svgrepo-com" transform="translate(653.418 307.5)">
                            <path id="Tracé_2636" data-name="Tracé 2636" d="M107.422,14.421a7.211,7.211,0,1,0-7.211-7.21A7.218,7.218,0,0,0,107.422,14.421Zm0-10.9a3.688,3.688,0,1,1-3.688,3.688A3.692,3.692,0,0,1,107.422,3.523Z" transform="translate(-8.361)" fill="#818181"/>
                            <path id="Tracé_2637" data-name="Tracé 2637" d="M101.847,68.914H96.318c-3.879,0-7.035,2.249-7.035,5.013v8.448a4.725,4.725,0,0,0,2.81,4V99.974c0,.693.789,1.255,1.761,1.255s1.761-.562,1.761-1.255V85.7a1.278,1.278,0,0,0-.94-1.11,2.546,2.546,0,0,1-1.87-2.211V73.927c0-1.38,1.576-2.5,3.513-2.5h5.529c1.937,0,3.513,1.123,3.513,2.5v8.448a2.547,2.547,0,0,1-1.872,2.212,1.278,1.278,0,0,0-.939,1.109V99.974c0,.693.789,1.255,1.761,1.255s1.761-.562,1.761-1.255V86.379a4.725,4.725,0,0,0,2.811-4V73.927C108.883,71.163,105.727,68.914,101.847,68.914Z" transform="translate(0 -52.729)" fill="#818181"/>
                        </g>
                    </g>
                    <g v-if="name == 'Produits'"  id="produits" transform="translate(-961 -289)">
                        <g id="Ellipse_77" data-name="Ellipse 77" transform="translate(961 289)" fill="#efefef" stroke="#c3c3c3" stroke-width="1">
                            <circle cx="42" cy="42" r="42" stroke="none"/>
                            <circle cx="42" cy="42" r="41.5" fill="none"/>
                        </g>
                        <g id="perfume-fashion-svgrepo-com" transform="translate(895.477 307.001)">
                            <g id="Groupe_1733" data-name="Groupe 1733" transform="translate(92.523 -0.001)">
                                <g id="Groupe_1732" data-name="Groupe 1732" transform="translate(0 0)">
                                    <path id="Tracé_2790" data-name="Tracé 2790" d="M109.746,26.869q-.159-.107-.32-.207V22.7a1.521,1.521,0,0,0-1.522-1.522h-.16V17.176a.757.757,0,0,0-.8-.8h-4.806a.757.757,0,0,0-.8.8v4.005h-.08A1.521,1.521,0,0,0,99.733,22.7v3.905c-.135.083-.269.169-.4.261a14.8,14.8,0,0,0-6.809,12.817v1.442a18.43,18.43,0,0,0,.632,4.587c.023.09.047.18.072.27q.047.176.1.35l4.806,15.941a1.1,1.1,0,0,0,.13.2l.11.36h12.337l.093-.3a1.111,1.111,0,0,0,.147-.176l4.887-16.022a18.144,18.144,0,0,0,.721-4.166.953.953,0,0,0-.02-.185q.019-.428.02-.856V39.687A14.8,14.8,0,0,0,109.746,26.869Zm-6.809-8.892h3.2v.8h-.8a.8.8,0,1,0,0,1.6h.8v.8h-3.2Zm-1.6,4.806h6.409v3.044a8.184,8.184,0,0,0-1.784-.464,9.078,9.078,0,0,0-4.625.458V22.784Zm8.171,38.452H99.492L94.846,45.775q-.132-.417-.239-.842a16.187,16.187,0,0,1-.4-2.6,6.976,6.976,0,0,1,9.773.32c.08.08.08.16.16.16a8.614,8.614,0,0,0,10.549,1.216c-.023.124-.047.247-.073.37-.127.489-.255.948-.382,1.458Zm5.447-20.107q0,.321-.013.642a6.962,6.962,0,0,1-9.76-.322c-.08-.08-.08-.16-.16-.16a8.818,8.818,0,0,0-6.088-2.483,8.285,8.285,0,0,0-4.806,1.534v-.733a12.96,12.96,0,0,1,6.168-11.375,7.609,7.609,0,0,1,8.572,0,13.353,13.353,0,0,1,6.088,11.455v1.442Z" transform="translate(-92.523 -14.838)" fill="#707070"/>
                                    <path id="Tracé_2791" data-name="Tracé 2791" d="M392.79,41.975h-.8a.8.8,0,0,0,0,1.6h.8a.8.8,0,1,0,0-1.6Z" transform="translate(-363.15 -38.034)" fill="#707070"/>
                                    <path id="Tracé_2792" data-name="Tracé 2792" d="M290.39,43.578a.8.8,0,0,0,0-1.6h-.8a.8.8,0,0,0,0,1.6Z" transform="translate(-270.363 -38.035)" fill="#707070"/>
                                    <path id="Tracé_2793" data-name="Tracé 2793" d="M358.657,41.975h-.8a.8.8,0,1,0,0,1.6h.8a.8.8,0,0,0,0-1.6Z" transform="translate(-332.222 -38.034)" fill="#707070"/>
                                    <path id="Tracé_2794" data-name="Tracé 2794" d="M324.524,41.975h-.8a.8.8,0,0,0,0,1.6h.8a.8.8,0,1,0,0-1.6Z" transform="translate(-301.293 -38.034)" fill="#707070"/>
                                    <path id="Tracé_2795" data-name="Tracé 2795" d="M289.443,16.284h.16l.8-.16a.817.817,0,0,0-.32-1.6l-.8.16a.811.811,0,0,0-.641.961A.78.78,0,0,0,289.443,16.284Z" transform="translate(-270.217 -13.145)" fill="#707070"/>
                                    <path id="Tracé_2796" data-name="Tracé 2796" d="M322.723,9.457c.08,0,.08-.08.16,0l.8-.16a.817.817,0,0,0-.32-1.6l-.8.16a.811.811,0,0,0-.641.961A.78.78,0,0,0,322.723,9.457Z" transform="translate(-300.373 -6.958)" fill="#707070"/>
                                    <path id="Tracé_2797" data-name="Tracé 2797" d="M356,1.777h.16l.8-.16A.811.811,0,0,0,357.6.655a.811.811,0,0,0-.961-.641l-.8.16a.811.811,0,0,0-.641.961A.78.78,0,0,0,356,1.777Z" transform="translate(-330.528 0.001)" fill="#707070"/>
                                    <path id="Tracé_2798" data-name="Tracé 2798" d="M322.589,76.711l.8.16h.16a.843.843,0,0,0,.8-.641.879.879,0,0,0-.641-.961l-.8-.16a.811.811,0,0,0-.961.641A.879.879,0,0,0,322.589,76.711Z" transform="translate(-300.399 -68.044)" fill="#707070"/>
                                    <path id="Tracé_2799" data-name="Tracé 2799" d="M356.991,82.949l-.8-.16a.851.851,0,0,0-.961.641.878.878,0,0,0,.641.961l.8.16h.16a.843.843,0,0,0,.8-.641A.879.879,0,0,0,356.991,82.949Z" transform="translate(-330.556 -75.003)" fill="#707070"/>
                                    <path id="Tracé_2800" data-name="Tracé 2800" d="M289.309,69.058l.8.16h.16a.921.921,0,0,0,.8-.641.879.879,0,0,0-.641-.961l-.8-.16a.817.817,0,0,0-.32,1.6Z" transform="translate(-270.243 -61.112)" fill="#707070"/>
                                </g>
                            </g>
                        </g>
                    </g>
                    <g v-if="name == 'Abonnements'" id="abonnements" transform="translate(-461 -522)">
                        <g id="Ellipse_80" data-name="Ellipse 80" transform="translate(461 522)" fill="#efefef" stroke="#c3c3c3" stroke-width="1">
                            <circle cx="42" cy="42" r="42" stroke="none"/>
                            <circle cx="42" cy="42" r="41.5" fill="none"/>
                        </g>
                        <g id="spa-svgrepo-com" transform="translate(477 539)">
                            <path id="Tracé_2632" data-name="Tracé 2632" d="M25.684,26.191C16.215,12.1,5.377,9.51,4.889,9.4L2,8.75v2.961c0,17.266,9.3,28.421,23.684,28.421,14.166,0,23.684-11.421,23.684-28.421V8.75L46.479,9.4C45.991,9.51,35.153,12.1,25.684,26.191Z" transform="translate(0 7.868)" fill="none" stroke="#707070" stroke-width="2.5"/>
                            <path id="Tracé_2633" data-name="Tracé 2633" d="M15.985,4.817A39.374,39.374,0,0,0,7.831,17.357a35.626,35.626,0,0,1,9.85,8.728A34.393,34.393,0,0,1,27.558,17.3,39.483,39.483,0,0,0,19.422,4.817L17.7,3Z" transform="translate(7.979)" fill="none" stroke="#707070" stroke-width="2.5"/>
                        </g>
                    </g>
                   <g v-if="name == 'Cures'" id="cures" transform="translate(-711 -522)">
                        <g id="Ellipse_79" data-name="Ellipse 79" transform="translate(711 522)" fill="#efefef" stroke="#c3c3c3" stroke-width="1">
                            <circle cx="42" cy="42" r="42" stroke="none"/>
                            <circle cx="42" cy="42" r="41.5" fill="none"/>
                        </g>
                        <g id="health-care-svgrepo-com" transform="translate(731 533.041)">
                            <path id="Tracé_2801" data-name="Tracé 2801" d="M24.6,46.932a9.891,9.891,0,0,1-2.629,1.952c-.785-.235-2.066-1.425-3.939-3.164q-.477-.443-1.016-.941C10.054,38.358,2.584,28.963,2.5,21.85a7.9,7.9,0,0,1,2.489-6.067,11.631,11.631,0,0,1,16.126-.152,1.25,1.25,0,0,0,1.716,0,11.632,11.632,0,0,1,16.126.152c3.508,3.394,3.313,8.523-.579,15.245A1.25,1.25,0,0,0,40.54,32.28c5.657-9.769,3.207-15.34.154-18.294a14.133,14.133,0,0,0-18.722-.921,14.132,14.132,0,0,0-18.721.921A10.408,10.408,0,0,0,0,21.879C.12,31.831,11.757,43.329,15.321,46.616q.536.495,1.009.935c2.612,2.425,3.923,3.642,5.479,3.847a1.252,1.252,0,0,0,.325,0c1.251-.164,2.377-1.01,4.145-2.616a1.249,1.249,0,0,0-1.68-1.85Z" transform="translate(0)" fill="#707070"/>
                            <path id="Tracé_2802" data-name="Tracé 2802" d="M199.887,171.731h-4.013v-4.013a1.25,1.25,0,0,0-1.25-1.25H189.6a1.25,1.25,0,0,0-1.25,1.25v4.013h-4.013a1.25,1.25,0,0,0-1.25,1.25v5.025a1.25,1.25,0,0,0,1.25,1.25h4.013v4.013a1.25,1.25,0,0,0,1.25,1.25h5.025a1.25,1.25,0,0,0,1.25-1.25v-4.013h4.013a1.25,1.25,0,0,0,1.25-1.25v-5.025A1.25,1.25,0,0,0,199.887,171.731Zm-1.25,5.025h-4.013a1.25,1.25,0,0,0-1.25,1.25v4.013h-2.526v-4.013a1.25,1.25,0,0,0-1.25-1.25h-4.013V174.23H189.6a1.25,1.25,0,0,0,1.25-1.25v-4.013h2.526v4.013a1.25,1.25,0,0,0,1.25,1.25h4.013Z" transform="translate(-160.21 -136.954)" fill="#707070"/>
                        </g>
                    </g>
                   <g v-if="name == 'Bons cadeau'" id="bons_cadeau" data-name="bons cadeau" transform="translate(-461 -289)">
                        <g id="Ellipse_76" data-name="Ellipse 76" transform="translate(461 289)" fill="#efefef" stroke="#c3c3c3" stroke-width="1">
                            <circle cx="42" cy="42" r="42" stroke="none"/>
                            <circle cx="42" cy="42" r="41.5" fill="none"/>
                        </g>
                        <g id="gift-svgrepo-com" transform="translate(473.352 307.97)">
                            <g id="Groupe_811" data-name="Groupe 811" transform="translate(7.294 0)">
                                <path id="Tracé_2629" data-name="Tracé 2629" d="M49.86,8.774H37.719l1.062-.951a1.416,1.416,0,0,0,.209-.233A4.854,4.854,0,0,0,37.858.827a4.45,4.45,0,0,0-6.5,1.5l-2.075,3.83-2.075-3.83a4.45,4.45,0,0,0-6.5-1.5A4.854,4.854,0,0,0,19.581,7.59a1.425,1.425,0,0,0,.209.233l1.062.951H8.712a1.418,1.418,0,0,0-1.418,1.418v8.99A1.418,1.418,0,0,0,8.712,20.6h.376V44.819a1.418,1.418,0,0,0,1.418,1.418h37.56a1.418,1.418,0,0,0,1.418-1.418V20.6h.376a1.418,1.418,0,0,0,1.418-1.418v-8.99A1.418,1.418,0,0,0,49.86,8.774ZM33.854,3.681a1.593,1.593,0,0,1,1.055-.8,1.639,1.639,0,0,1,.371-.043,1.593,1.593,0,0,1,.93.3,2.013,2.013,0,0,1,.546,2.693L33.468,8.774H31.1Zm-12.31.761a2,2,0,0,1,.816-1.306,1.614,1.614,0,0,1,2.357.545l2.759,5.092H25.1L21.814,5.829A2,2,0,0,1,21.544,4.442ZM24.009,43.4H11.923V20.6H24.009Zm7.718,0H26.845V20.6h4.882Zm14.922,0H34.562V20.6H46.648Zm1.794-25.637H10.13V11.61H48.441v6.154Z" transform="translate(-7.294 0)" fill="#818181"/>
                            </g>
                        </g>
                    </g>
                   <g v-if="name == 'Forfaits'" id="forfaits" transform="translate(-461 -786)">
                        <g id="abonnements" transform="translate(0 264)">
                            <g id="Ellipse_80" data-name="Ellipse 80" transform="translate(461 522)" fill="#efefef" stroke="#c3c3c3" stroke-width="1">
                                <circle cx="42" cy="42" r="42" stroke="none"/>
                                <circle cx="42" cy="42" r="41.5" fill="none"/>
                            </g>
                        </g>
                        <path id="path4944" d="M23.32,0,0,6.264V34.45l23.32,6.264,23.32-6.264V6.264ZM3.1,32.147,3.085,10.961l18.681,5.017V37.159L3.1,32.147ZM3.085,7.83l7.786-2.091,20.223,5.438L23.32,13.265ZM43.538,32.147,24.875,37.159V15.979l6.219-1.67v7.634l6.219-1.67V12.638l6.243-1.677-.018,21.185ZM37.313,9.506V9.5L17.089,4.069,23.32,2.395,43.556,7.83Z" transform="translate(479.18 811)" fill="#8e8e8e"/>
                    </g>
                </svg>
                <span class="h5 pt-3 text-center" style="color:  #000">{{ name }}</span>
            </div>
          </div>
        </div>
      </div>

      <!-- Categories 'Type Array' - Sous-catégories -->
      <div v-else class="row items-push">
        <div
          v-for="(value, index) of actualCardsWithoutColor"
          :key="index"
          v-if="value && value.id"
          @click="nextStep(value, value.name, value.id, true)"
          class="col-4 col-md-3"
        >
          <div
            class="block block-rounded rounded-circle h-100 mb-0 ratio ratio-1x1 shadow"
            :style="value.color ? `background-color: ${value.color}` : 'background-color: #3e4254'"
            role="button"
          >
            <div class="block-content d-flex justify-content-center align-items-center">
              <p class="h5 text-light text-center">{{ value.name }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Prestations & Produits -->
    <div v-else class="row items-push mt-4">
      <div v-if="noResults">
        <p>Aucun résultat pour cette sous-catégorie.</p>
      </div>
      <div v-if="!actualCardsWithoutColor.length && researchValue && !loading">
        Ancun résultat trouvé
      </div>
      <div v-for="(value, index) in actualCardsWithoutColor" :key="value.id" class="col-4" v-if="value && value.id">
        <form v-if="!isVoucher" method="POST" :action="prestaAdd">
          <input type="hidden" name="_token" :value="csrf" ref="_token" />
          <input type="hidden" name="type" :value="currentCategory || value.cat" />
          <input type="hidden" name="item_id" :value="value.id" />
          <input type="hidden" name="price_ht" :value="value.price_ht" />
          <input v-if="orderId" type="hidden" name="order_id" :value="orderId" />
          <input v-if="userId" type="hidden" name="user_id" :value="userId" />
          <button type="submit" style="width: 100%;">
            <div class="block block-rounded h-100 mb-0">
              <div class="block-content position-relative p-1">
                <span class="badge rounded-pill bg-primary" style="position: absolute; top: -10px; right: -10px; z-index: 2"
                  >{{ value.price }}€</span
                >
                <div class="options-container">
                  <img
                    style="height: 160px;width: 100%;object-fit: cover;"
                    class="p-0 img-thumbnail options-item"
                    v-if="value.img1"
                    :src="value?.img1 || '/media/default.jpg'"
                    :alt="value.name"
                  />
                  <img
                    style="height: 160px;width: 100%;object-fit: cover;"
                    class="p-0 img-thumbnail options-item"
                    v-else
                    :src="value?.image || '/media/default.jpg'"
                    :alt="value.name"
                  />
                </div>
              </div>
              <div class="block-content">
                <!-- #TODO Définir si l'on trie dans le controler les produit et prestations non vendable {{ value}} -->
                <div class="mb-1">
                  <input
                    type="hidden"
                    id="priceModalPresta"
                    name="priceModalPresta"
                    :value="value.price"
                    ref="priceModalPresta"
                  />
                  <p class="h6">{{ value?.name }}</p>
                  <input type="hidden" id="prestationLabel" name="prestationLabel" :value="value.name" ref="prestationLabel" />
                  <input
                    type="hidden"
                    id="quantity"
                    name="quantity"
                    onchange="this.form.submit()"
                    class="input-number"
                    min="1"
                    value="1"
                    ref="quantity"
                  />
                </div>
                <p v-if="isPrestation" class="fs-sm text-muted">{{ value.commercial_time }} min</p>
                <p v-if="isProduct" class="fs-sm text-muted">Quantité disponible : {{ value.quantity }}</p>
                <input type="hidden" id="timeQty" name="timeQty" :value="value.duration" ref="timeQty" />
                <input type="hidden" id="prestaStatus" name="prestaStatus" value="1" ref="prestaStatus" />
              </div>
            </div>
          </button>
        </form>

        <!-- bon cadeau -->
        <form v-else method="POST" :action="voucherAdd" ref="formPrestaAdd">
          <input type="hidden" name="_token" :value="csrf" ref="_token" />
          <input type="hidden" name="type" :value="value.cat" />
          <input type="hidden" name="item_id" :value="value.id" />
          <input type="hidden" name="amount" :value="amount" />
          <input v-if="orderId" type="hidden" name="order_id" :value="orderId" />
          <input v-if="userId" type="hidden" name="user_id" :value="userId" />
          <input type="hidden" name="bonCadeau" :value="true" />

            <div class="block block-rounded h-100 mb-0">
              <div class="block-content position-relative p-1">
                <span class="badge rounded-pill bg-primary" style="position: absolute; top: -10px; right: -10px; z-index: 2"
                  >{{ value.price }}€</span
                >
                <div class="options-container">
                  <img
                    style="height: 160px;width: 100%;object-fit: cover;"
                    class="p-0 img-thumbnail options-item"
                    :src="value?.image || '/media/default.jpg'"
                    :alt="value.name"
                  />
                </div>
              </div>
              <div class="block-content">
                <div class="mb-1">
                  <input
                    type="hidden"
                    id="priceModalPresta"
                    name="priceModalPresta"
                    :value="value.price"
                    ref="priceModalPresta"
                  />
                  <p class="h6">{{ value.name }}</p>
                  <input type="hidden" id="prestationLabel" name="prestationLabel" :value="value.name" ref="prestationLabel" />
                  <input
                     v-if="isPrestation"
                    type="number"
                    id="quantity"
                    name="quantity"
                    class="input-number"
                    min="1"
                    value="1"
                    ref="quantity"
                  />
                  <input
                     v-else
                    type="hidden"
                    id="quantity"
                    name="quantity"
                    class="input-number"
                    min="1"
                    value="1"
                    ref="quantity"
                  />
                </div>
                <p v-if="isPrestation" class="fs-sm text-muted">{{ value.commercial_time }} min</p>
                <input type="hidden" id="timeQty" name="timeQty" value="30" ref="timeQty" />
                <input type="hidden" id="prestaStatus" name="prestaStatus" value="1" ref="prestaStatus" />
              </div>
              <button type="submit" class="btn btn-primary" style="width: 100%;">valider</button>
            </div>
        </form>

        <div :id="{ 'modal-overlay': modalVoucher }"></div>
      </div>
    </div>
    <div
      v-if="fixedAmount"
      class="modal fade"
      :class="{ show: fixedAmount }"
      id="modalVoucher"
      tabindex="-1"
      role="dialog"
      aria-labelledby="modalVoucherLabel"
      aria-hidden="true"
      style="display: block"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content rounded-24 overflow-hidden">
          <div class="block  rounded-24 block-transparent mb-0">
            <div class="block-header">
              <h3 class="block-title fs-3 d-flex justify-content-center">
                  <svg xmlns="http://www.w3.org/2000/svg" width="22.772" height="20.675" viewBox="0 0 25.772 27.675" style="display: inline-block;margin: 0 5px;">
                      <path id="gift-svgrepo-com" d="M39.414,4.525H38.152c0-1.418-.058-2.739-.955-3.637A3.509,3.509,0,0,0,34.583,0a9.611,9.611,0,0,0-6.62,2.777A9.611,9.611,0,0,0,21.343,0a3.509,3.509,0,0,0-2.613.888c-.9.9-.954,2.22-.955,3.637H16.512a.935.935,0,0,0-.935.935V26.74a.935.935,0,0,0,.935.935h22.9a.935.935,0,0,0,.935-.935V5.46A.935.935,0,0,0,39.414,4.525Zm-.935,4.911H31.352V6.4h7.128ZM26.444,6.4h3.038V16.536l-1-.667a.934.934,0,0,0-1.037,0l-1,.667V6.4Zm8.14-4.526a1.846,1.846,0,0,1,1.29.339,3.808,3.808,0,0,1,.409,2.317H29.031C29.648,3.206,32.3,1.87,34.583,1.87Zm-14.531.339a1.845,1.845,0,0,1,1.29-.339c2.284,0,4.935,1.337,5.552,2.656H19.644A3.807,3.807,0,0,1,20.052,2.209ZM24.574,6.4V9.436H17.447V6.4Zm-7.128,19.41v-14.5h7.128v6.977a.935.935,0,0,0,1.454.778l1.935-1.291L29.9,19.061a.935.935,0,0,0,1.454-.778V11.306h7.128v14.5Z" transform="translate(-15.577)"></path>
                  </svg>Bon cadeau</h3>
<!--              <div class="block-options">
                <button type="button" class="btn-block-option" @click="closeVoucherModal">
                  <i class="fa fa-fw fa-times"></i>
                </button>
              </div>-->
            </div>
            <form :action="voucherAdd" method="POST">
              <div class="block-content d-flex flex-column fs-sm mb-4">
                <input type="hidden" name="_token" :value="csrf" ref="_token" />
                <input type="hidden" name="type" :value="currentCategory" />
                <input v-if="orderId" type="hidden" name="order_id" :value="orderId" />
                <input v-if="userId" type="hidden" name="user_id" :value="userId" />
                <input
                  type="hidden"
                  id="prestationLabel"
                  name="prestationLabel"
                  :value="'Bon cadeau de ' + amount + '€'"
                  ref="prestationLabel"
                />
                 <label class="form-label" for="amount">
                      Quantité
                      <span class="text-danger">*</span>
                    </label>
                <input
                  type="number"
                  id="quantity"
                  name="quantity"
                  class="input-number rounded-24 w-25"
                 style="min-width: 100px"
                  min="1"
                  value="1"
                  ref="quantity"
                />
                <div class="row">
                  <div class="col-12">
                    <label class="form-label" for="amount">
                      Montant de votre bon cadeau
                      <span class="text-danger">*</span>
                    </label>
                    <div class="input-group rounded-24 overflow-hidden">
                      <span class="input-group-text bg-primary text-white border-0 px-3">€</span>
                      <input
                        type="number"
                        min="1"
                        step="0.01"
                        class="form-control "
                        style="border-radius: 0 24px 24px 0"
                        id="amount"
                        name="amount"
                        placeholder="Montant"
                        v-model="amount"
                      />
                      <input type="hidden" id="priceModalPresta" name="priceModalPresta" :value="amount" ref="priceModalPresta" />
                    </div>
                  </div>
                </div>
              </div>
              <div class="block-content block-content-full text-center">
                <button
                  type="button"
                  data-bs-dismiss="modal"
                  style="min-width: 120px"
                  class="btn btn-sm btn-alt-secondary me-1 rounded-pill py-2 px-3"
                  @click="closeVoucherModal"
                >
                  Fermer
                </button>
                <button type="submit" class="btn btn-sm btn-yellow rounded-pill py-2 px-3">Ajouter au bon cadeau</button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
    <div v-if="modalVoucher || fixedAmount" :class="{ show: modalVoucher || fixedAmount }" class="modal-backdrop fade"></div>
  </div>
</template>

<style>
input[type="number"]
{
  -moz-appearance: none;
}
input[type=number]::-webkit-inner-spin-button,
input[type=number]::-webkit-outer-spin-button {
      -webkit-appearance: none;
      margin: 0;
}
.v-application--wrap {
  flex: 1 1 auto;
  -webkit-backface-visibility: hidden;
  backface-visibility: hidden;
  display: flex;
  flex-direction: column;
  min-height: 20vh;
  max-width: 100%;
  position: relative;
}
</style>

<script>
/*
 *   Categories:
 */

export default {
  props: [
    'prestaAdd',
    'voucherAdd',
    'getPrestationsBySubcategory',
    'getPrestationsByVoucherSubcategory',
    'getProductsBySubcategory',
    'categories',
    'questions',
    'researchRoute',
    'currentCustomer',
    'orderId',
    'userId'
  ],
  name: 'checkout-component',
  components: {
    DialogAlerte: () => import('../Calendar/Modal/parts/DialogAlerte.vue'),
  },
  data: () => ({
    breadcrumb: [],
    actualCards: null,
    showCategories: true,
    csrf: document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
    isPrestation: false,
    isProduct: false,
    isSerie: false,
    isVoucher: false,
    researchValue: '',
    currentCategory: null,
    noResults: false,
    lastRequest: new Date(),
    loading: false,
    timeout: null,
    alertRebooking: null,

    // Voucher Prestation modal
    modalVoucher: false,
    fixedAmount: false,
    amount: 1,
  }),
  computed: {
    actualCardsWithoutColor: function() {
      if (Array.isArray(this.actualCards)) {
        return this.actualCards.filter(i => typeof i !== 'string')
      }

      return this.actualCards
    },
  },
  mounted() {
    this.actualCards = this.categories
  },
  methods: {
    searchInput() {
        this.loading = true
        if (this.timeout) {
            clearTimeout(this.timeout)
        }
        this.timeout = setTimeout(() => {
            this.research()
            this.loading = false
        }, 500)
    },
    hasCustomColor(value) {
      return typeof value[value.length - 1] === 'string' && value[value.length - 1] !== ''
    },

    getCustomColor(value) {
      return value[value.length - 1]
    },

    rollback(val, index) {
      console.log(val)
      if (val.name == 'Prestations' || val.name == 'Prestations') {
        this.isPrestation = false
        this.isProduct = false
      }
      this.isVoucher = false
      this.fixedAmount = false

      this.actualCards = val.previousCategory
      this.breadcrumb = this.breadcrumb.slice(0, index)
      this.showCategories = true
    },

    nextStep(event, name, id, isLastStep = false) {
      console.log(event, name, id)
      switch (name) {
        case 'Prestations':
          if (this.breadcrumb.filter(e => e.name === 'Bons cadeau').length > 0) {
            this.isVoucher = true
          }
          this.currentCategory = name
          this.isPrestation = true

          break

        case 'Produits':
          this.isProduct = true
          this.currentCategory = name
          break
        case 'Abonnements':
          this.currentCategory = name
          isLastStep = true
          break
        case 'Forfaits':
          this.currentCategory = name
          isLastStep = true
          break
        case 'Bons cadeau':
          this.isVoucher = true
          this.currentCategory = name
          break
        case 'Cures':
          this.currentCategory = name
          isLastStep = true
          break
        case 'Montant fixe':
          isLastStep = true
          this.fixedAmount = true
          this.modalVoucher = true
          this.currentCategory = 'Bons cadeau'
          break

        default:
          break
      }
      this.breadcrumb.push({ name: name, id: id, previousCategory: this.actualCards })
      this.actualCards = event

      if (isLastStep && id !== null) {
        this.showCategories = false
        if (this.isPrestation) this.getPrestations(id)
        //if (this.isVoucher) this.getPrestationsVoucher(27)
        if (this.isProduct) this.getProducts(id)
      }
    },

    async research() {
      const targetDate = new Date();
      if (this.researchValue.length > 0) {
        this.loading = true;
        axios
          .get(this.researchRoute, { params: { name: this.researchValue, category: this.currentCategory } })
          .then(res => {
            if (targetDate <= this.lastRequest) return

            this.showCategories = false
            this.actualCards = res.data
            this.lastRequest = targetDate;
          })
          .catch(error => {
            console.log(error)
          })
          .finally(() => {
            this.loading = false
          })
      } else {
        this.showCategories = true
        this.currentCategory = null
        this.actualCards = this.categories
        this.breadcrumb.splice(0)
        this.lastRequest = targetDate;
        // switch (this.currentCategory) {
        //   case 'Prestations':
        //     if (this.breadcrumb.filter(e => e.name === 'Bons cadeau').length > 0) {
        //       this.isVoucher = true
        //       console.log('voucher')
        //     }
        //     this.isPrestation = true
        //     this.actualCards = this.categories

        //     break
        //   case 'Produits':
        //     this.isProduct = true
        //     this.actualCards = this.categories
        //     break
        //   case 'Abonnements':
        //     this.showCategories = false
        //     break
        //   case 'Forfaits':
        //     this.showCategories = false
        //     break
        //   case 'Bons cadeau':
        //     this.isVoucher = true
        //     this.actualCards = this.categories
        //     break
        //   case 'Cures':
        //     this.showCategories = false
        //     break

        //   default:
        //     this.showCategories = true
        //     this.actualCards = this.categories
        //     break
        // }
      }
    },

    async getPrestations(subcategory) {
      axios
        .get(this.getPrestationsBySubcategory, { params: { id: subcategory } })
        .then(res => {
          this.actualCards = res.data
          if (res.data.length == 0) {
            this.noResults = true
          }
        })
        .catch(error => {
          console.log(error)
        })
    },

    async getPrestationsVoucher(subcategory) {
      axios
        .get(this.getPrestationsByVoucherSubcategory, { params: { id: subcategory } })
        .then(res => {
          this.actualCards = res.data
          if (res.data.length == 0) {
            //this.noResults = true
          }
        })
        .catch(error => {
          console.log(error)
        })
    },

    async getProducts(subcategory) {
      axios
        .get(this.getProductsBySubcategory, { params: { id: subcategory } })
        .then(res => {
          this.actualCards = res.data
          if (res.data.length == 0) {
            this.noResults = true
          }
        })
        .catch(error => {
          console.log(error)
        })
    },

    openVoucherModal(index) {
      this.$refs.modalVoucher[index].classList.remove('hide')
      this.$refs.modalVoucher[index].classList.add('show')
      this.$refs.modalVoucher[index].style.display = 'block'
      this.modalVoucher = true
    },

    closeVoucherModal(index = null) {
      this.modalVoucher = false
      this.isVoucher = false

      if (this.fixedAmount) {
        this.fixedAmount = false

        // Retour à l'affichage des catégories
        this.showCategories = true
        this.actualCards = this.categories
        this.breadcrumb = []
      } else {
        this.$refs.modalVoucher[index].classList.add('hide')
        this.$refs.modalVoucher[index].classList.remove('show')
        this.$refs.modalVoucher[index].style.display = 'none'
      }
    },

    modalSubmit(index) {
      this.$refs.formPrestaAdd[index].submit()
    },

    blockEnterKey(event) {
      console.log(event)
      event.preventDefault()
      return false
    },
  },
}
</script>

<style></style>
